'use client';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@tolstoy/ui-library/core';
import { useUserDataStore } from '@/stores/userDataStore';
import { useAvailableShopifyAppUrls } from '@/api/queries/useAvailableShopifyAppUrls';
import { useShallow } from 'zustand/react/shallow';

const ShopifyStoreSelector: React.FC = () => {
  const { appKey, appUrl, setAppUrl } = useUserDataStore(
    useShallow((state) => state)
  );
  const { stores, isLoading } = useAvailableShopifyAppUrls(appKey);

  if (isLoading || stores.length <= 1) {
    return null;
  }

  return (
    <div className="border-t py-2 lg:px-4">
      <Select value={appUrl} onValueChange={setAppUrl}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Theme" />
        </SelectTrigger>
        <SelectContent>
          {stores.map((store) => {
            return store ? (
              <SelectItem key={store} value={store}>
                {store}
              </SelectItem>
            ) : (
              <></>
            );
          })}
        </SelectContent>
      </Select>
    </div>
  );
};

export default ShopifyStoreSelector;
